import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uk-width-1-6" }
const _hoisted_2 = { class: "uk-width-1-3" }
const _hoisted_3 = { class: "uk-width-1-6" }
const _hoisted_4 = { class: "uk-width-1-6" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "image-action-icons" }
const _hoisted_7 = ["uk-tooltip", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_table = _resolveComponent("base-table")!

  return (_openBlock(), _createBlock(_component_base_table, { id: "images-table" }, {
    tableHead: _withCtx(() => [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.$t('index_templates.images_table.title')), 1),
        _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('index_templates.images_table.preview')), 1),
        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('index_templates.images_table.size')), 1),
        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('index_templates.images_table.actions')), 1)
      ])
    ]),
    tableBody: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: image.id
        }, [
          _createElementVNode("td", null, _toDisplayString(image.title), 1),
          _createElementVNode("td", null, [
            _createElementVNode("img", {
              src: image.thumbUrl
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("td", null, _toDisplayString(`${image.width}x${image.height}`), 1),
          _createElementVNode("td", _hoisted_6, [
            _createElementVNode("span", {
              "uk-icon": "icon: trash",
              class: _normalizeClass(["action-icon", { 'disabled-icon': !_ctx.canDeleteImages }]),
              "uk-tooltip": 
              _ctx.canDeleteImages ? false : _ctx.$t('permissions.action_not_allowed')
            ,
              onClick: ($event: any) => (_ctx.canDeleteImages && _ctx.$emit('delete', image))
            }, null, 10, _hoisted_7)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }))
}